import React from 'react';

import PageHeader from '../components/header/page';
import FeatureHeadline from '../components/headline';
import AvatarGrid from '../components/avatargrid';

import CustomSlider from '../components/slider';

const AboutPage = props =>
  (<main>
    <PageHeader headline="Über uns" nobottom/>
    <CustomSlider />
    <FeatureHeadline
      title="Wir machen alles von der Neurologie
      über Onkologie bishin zur Urologie"
      linktitle="Zu unseren Leistungen"
      link="/leistungen"
      devices
      centered
      contained
    />
    <FeatureHeadline title="Unser Ärzteteam" transparent centered contained>
      <p>In der Radiologie Bregenz werden sämtliche radiologischen Untersuchungen von unserem qualifiziertem Ärzteteam durchgeführt und beurteilt.</p><br/>
      <p>Unsere Ärzte besuchen regelmäßig Fortbildungsveranstaltungen. Dadurch wird gewährleistet, dass die angebotenen Untersuchungen den neuesten medizinischen Standards gerecht werden. Für alle Fragen der Diagnostik sind wir ein kompetenter Ansprechpartner.</p>
    </FeatureHeadline>
    <AvatarGrid split/>
  </main>);

export default AboutPage;


// WEBPACK FOOTER //
// ./src/pages/about.js